import IconButton from '@mui/material/IconButton';
import {
	FirstPage as FirstPageIcon,
	KeyboardArrowLeft,
	KeyboardArrowRight,
	LastPage as LastPageIcon,
} from '@mui/icons-material';
import React from 'react';
import PropTypes from 'prop-types';

class TablePaginationActions extends React.Component {
	handleFirstPageButtonClick = (event) => {
		this.props.onPageChange(event, 0);
	};

	handleBackButtonClick = (event) => {
		this.props.onPageChange(event, this.props.page - 1);
	};

	handleNextButtonClick = (event) => {
		this.props.onPageChange(event, this.props.page + 1);
	};

	handleLastPageButtonClick = (event) => {
		this.props.onPageChange(event, Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));
	};

	render() {
		const { classes, count, page, rowsPerPage, theme } = this.props;
		const isRtl = theme.direction === 'rtl';

		const buttons = [
			{
				onClick: this.handleFirstPageButtonClick,
				disabled: page === 0,
				ariaLabel: 'First Page',
				icon: isRtl ? <LastPageIcon /> : <FirstPageIcon />,
			},
			{
				onClick: this.handleBackButtonClick,
				disabled: page === 0,
				ariaLabel: 'Previous Page',
				icon: isRtl ? <KeyboardArrowRight /> : <KeyboardArrowLeft />,
			},
			{
				onClick: this.handleNextButtonClick,
				disabled: page >= Math.ceil(count / rowsPerPage) - 1,
				ariaLabel: 'Next Page',
				icon: isRtl ? <KeyboardArrowLeft /> : <KeyboardArrowRight />,
			},
			{
				onClick: this.handleLastPageButtonClick,
				disabled: page >= Math.ceil(count / rowsPerPage) - 1,
				ariaLabel: 'Last Page',
				icon: isRtl ? <FirstPageIcon /> : <LastPageIcon />,
			},
		];

		return (
			<div className={classes.root}>
				{buttons.map((button, index) => (
					<IconButton
						key={index}
						onClick={button.onClick}
						disabled={button.disabled}
						aria-label={button.ariaLabel}
						size="large"
					>
						{button.icon}
					</IconButton>
				))}
			</div>
		);
	}
}

TablePaginationActions.propTypes = {
	classes: PropTypes.object.isRequired,
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
	theme: PropTypes.object.isRequired,
};

export default TablePaginationActions;
